import React from "react";
import styles from "./MoreButton.module.css";
import MoreIcon from "../../../assets/more.svg";

export default function MoreButton({ action }) {
	return (
		<div className={styles.moreButton} onClick={action}>
			<img src={MoreIcon} alt="More Icon" />
		</div>
	);
}
